import { BLADDER_FINDINGS } from "../groups/bladder";
import { multi, OTHER, option, type UsWorksheetDefinition } from "../us-fields";

export const US_BLADDER: UsWorksheetDefinition = {
  examType: "us_bladder",
  version: 1,
  indications: [
    option("urinary_retention", "Urinary retention"),
    option("foley_placement", "Assessment of foley placement"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "bladder",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: BLADDER_FINDINGS,
    },
    {
      id: "bladder_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("bladder.impression", "Impression", [
          option("urinary_retention", "Urinary retention"),
          option("no_urinary_retention", "No urinary retention"),
          option("foley_present", "Foley present in bladder"),
          option("foley_not_present", "Foley not present in bladder"),
          OTHER,
          option("indeterminate", "Indeterminate"),
        ]),
      ],
    },
  ],
  normalImpressions: [
    {
      sectionId: "bladder_impression",
      value: "no_urinary_retention",
    },
  ],
  billing: {
    codes: [
      {
        cpt: "76857",
        label: "Bladder ultrasound (without kidneys), including bladder volume",
        preTick: true,
      },
    ],
  },
};
